import React from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  margin-right: 10px;
`;

const DifferenceComponent = ({ diffsArr }) => {
  const renderDiffElement = ({
    isShown = true,
    uniqueChar,
    differenceValue,
    differencePercent,
  }) => {
    return (
      isShown && (
        <div key={uniqueChar}>
          <StyledSpan>Diff {uniqueChar}:</StyledSpan>
          <span className="tooltip-bold">
            {differenceValue} ({differencePercent}%)
          </span>
        </div>
      )
    );
  };

  return diffsArr.map(renderDiffElement);
};

export default DifferenceComponent;
